import { render } from "./Cataract.vue?vue&type=template&id=b7d64d64"
import script from "./Cataract.vue?vue&type=script&lang=js"
export * from "./Cataract.vue?vue&type=script&lang=js"

import "./Cataract.vue?vue&type=style&index=0&id=b7d64d64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__